import { render, staticRenderFns } from "./bidOpeningDetail.vue?vue&type=template&id=57a4d0b0&scoped=true"
import script from "./bidOpeningDetail.vue?vue&type=script&lang=js"
export * from "./bidOpeningDetail.vue?vue&type=script&lang=js"
import style0 from "./bidOpeningDetail.vue?vue&type=style&index=0&id=57a4d0b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57a4d0b0",
  null
  
)

export default component.exports